export default "__VITE_ASSET__Caq_uDV3__"